import React, { useState } from 'react';
import { Dropdown } from '../../Atoms/Dropdowns';
import { deleteEmail, patchEmail } from '../../Service/restapi/messageService';
import { TransButtonDefault, TransButtonLinkWithIcon, TransButtonPrimaryWithSpinner } from '../../Atoms/Buttons';
import { ModalDialog, useModalState } from '../Dialogs';
import { saveEventParticipation } from '../../Service/restapi/eventService';
import { getCustomerId } from '../../Service/restapi/contactService';
import EventSearchAutocomplete from '../../Organismns/Event/EventSearchAutocomplete';

const EmailActions = ({ email, changeEmailById, setEmailAction }) => {
  const { show, toggle } = useModalState();
  const [selectedEventId, setSelectedEventId] = useState(undefined);
  const [isSavingParticipation, setSavingParticipation] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [isMarking, setMarking] = useState(false);

  const items = [];

  if (!window.location.pathname.includes('events')) {
    items.push({ text: 'Event zuweisen', onClick: toggle });
  }

  if (window.location.pathname.includes('trash')) {
    items.push({ text: 'Wiederherstellen', onClick: () => trash(false) });
    items.push({ text: 'Endgültig löschen', onClick: deleteMail });
  } else {
    items.push({ text: 'Löschen', onClick: () => trash(true) });
  }

  if (email.readTimestamp && window.location.pathname.includes('inbox')) {
    items.push({ text: 'als unerledigt Markieren', onClick: () => markAsRead(false) });
  }

  function deleteMail() {
    deleteEmail(email.id)
      .then((resp) => {
        changeEmailById(email.id, undefined);
      })
      .catch((error) => {
        console.error(error.message);
      });
  }

  function trash(trash) {
    patchEmail(email.id, { trash })
      .then((resp) => {
        if (resp.ok) {
          changeEmailById(email.id, undefined);
        } else {
          console.error(`could not put email ${email.id} to trash`);
        }
      })
      .catch((error) => {
        console.error(error.message);
      });
  }

  function markAsRead(read) {
    setMarking(true);
    console.log(`mark email ${email.id} as read=${read}`);
    patchEmail(email.id, { read })
      .then((resp) => {
        resp
          .json()
          .then((updatedEmail) => {
            changeEmailById(email.id, updatedEmail);
          })
          .catch(() => {
            console.log('received no email update from server');
          });
      })
      .catch(() => {
        console.error(`could not mark email as read=${read}`);
      })
      .finally(() => {
        setMarking(false);
      });
  }

  function assignContactToEvent() {
    patchEmail(email.id, { eventId: selectedEventId })
      .then((resp) => {
        resp
          .json()
          .then((updatedEmail) => {
            changeEmailById(email.id, updatedEmail);
            toggle();
          })
          .catch(() => {
            console.log('received no email update from server');
          });
      })
      .catch(() => {
        console.error(`could not move email to event${selectedEventId}`);
      });

    let participation = {
      eventId: selectedEventId,
      eventRole: 'CUSTOMER',
    };
    const customerId = getCustomerId(email);

    if (customerId) {
      participation = {
        ...participation,
        contactId: customerId,
      };
    }
    saveEventParticipation(participation)
      .then((resp) => {
        if (resp.ok) {
        } else {
          console.error('could not save participation');
        }
      })
      .catch((error) => {
        console.error({ error });
        console.error('could not save participation');
      });
  }

  const styles = {
    dropdown: {
      padding: '0px 4px',
      borderRadius: '4px',
      textAlign: 'center',
      color: '#698aa6',
      fontWeight: 800,
    },
  };

  return (
    <div>
      {window.location.pathname.includes('/inbox') && (
        <TransButtonLinkWithIcon icon="REPLY" className="primary-link" onClick={() => setEmailAction('REPLY')} />
      )}
      &nbsp;
      {!email.readTimestamp && window.location.pathname.includes('/inbox') && (
        <TransButtonLinkWithIcon
          isLoading={isMarking}
          icon="CHECK"
          className="primary-link"
          onClick={() => markAsRead(true)}
        />
      )}
      &nbsp;
      {(window.location.pathname.includes('/scheduled') ||
        window.location.pathname.includes('/failed') ||
        (window.location.pathname.includes('/drafts') && email.localDateTime === null)) && (
        <TransButtonLinkWithIcon
          icon="EDIT"
          className="primary-link"
          onClick={() => setEmailAction('EDIT')}
          text="Bearbeiten"
        />
      )}
      &nbsp;
      <Dropdown style={styles.dropdown} caret={false} icon="DOTS" left value="" options={{ items }} />
      <ModalDialog
        header="Event zuweisen"
        body={<EventSearchAutocomplete selectEvent={(bookingEvent) => setSelectedEventId(bookingEvent.id)} />}
        footer={
          <div>
            <TransButtonPrimaryWithSpinner
              isLoading={isSavingParticipation}
              text="actions.save"
              icon="SAVE"
              onClickHandler={assignContactToEvent}
            />{' '}
            <TransButtonDefault onClickHandler={toggle} text="actions.close" />
          </div>
        }
        show={show}
        toggle={toggle}
      />
    </div>
  );
};

export default EmailActions;
